/**
 * Mantrana — DOMAIN-SPECIFIC EMOTIONAL QUESTION POOLS (Hindi / Devanagari).
 *
 * Mirrors mcqPool.js one-to-one. English metadata (archetype indices, scores)
 * stays canonical so aggregation is language-agnostic; only display text
 * changes here.
 *
 * Copy style: warm, spoken Hindi. NOT literary, NOT Sanskrit-heavy,
 * NOT Hinglish, NOT machine-translated. These should read like something a
 * close friend might quietly ask you.
 */

export const POOL_HI = {
  Career: {
    decision_confidence: [
      { q: "जब करियर का कोई बड़ा फ़ैसला सामने आता है, तो पहले क्या होता है?",
        o: [
          ["मैं दिमाग़ में हर पहलू तौलने लगता/लगती हूँ",                                  0],
          ["सोचने से पहले ही अंदर से जवाब मिल जाता है",                                 1],
          ["किसी अपने से खुलकर बात करने की ज़रूरत होती है",                              2],
          ["मैं टाल देता/देती हूँ — शायद बाद में स्पष्टता आ जाएगी",                      3],
        ] },
      { q: "आज आपकी करियर की स्थिति के बारे में कौन-सी बात सबसे सच लगती है?",
        o: [
          ["मैं जानता/जानती हूँ क्या चाहिए, पर हाथ तक नहीं पहुँचता",                       0],
          ["अंदर कुछ मुझे एक बड़े रूप की ओर खींच रहा है",                                 1],
          ["अगर सही आदमी कह दे कि ठीक है, तो मैं कदम उठा लूँ",                          2],
          ["अब समझ ही नहीं आता कि मुझे क्या चाहिए",                                    3],
        ] },
      { q: "जब कोई अच्छा मौक़ा आता है, आमतौर पर क्या होता है?",
        o: [
          ["मैं हर सम्भावना — अच्छी और बुरी — तौलता/तौलती हूँ",                          0],
          ["मन मना ले, उससे पहले 'हाँ' कह देता/देती हूँ",                                1],
          ["फ़ैसले से पहले अपनों से पूछता/पूछती हूँ",                                     2],
          ["मैं इतनी देर सोचता/सोचती हूँ कि मौक़ा निकल जाता है",                          3],
        ] },
      { q: "पिछला बड़ा करियर फ़ैसला असल में कैसे लिया था?",
        o: [
          ["सोच-समझकर — शोध, तुलना, विचार",                                          0],
          ["मन से — भीतर से लगा 'यही सही है'",                                        1],
          ["किसी क़रीबी के भरोसे पर",                                                 2],
          ["बहुत टालने की वजह से — जो हुआ, वो हो गया",                                3],
        ] },
    ],
    emotional_clarity: [
      { q: "इस समय अपने काम-काज को लेकर सबसे ज़्यादा क्या खलता है?",
        o: [
          ["थका हुआ महसूस करता/करती हूँ पर वजह ठीक से बता नहीं पाता/पाती",              0],
          ["आस-पास के लोग मुझे रोक रहे हैं",                                           1],
          ["मैं भीतर से चुपचाप सुन्न हो गया/गयी हूँ",                                    2],
          ["मुझे मालूम है क्या ठीक करना है — मैं कर भी रहा/रही हूँ",                    3],
        ] },
      { q: "जब काम में कुछ ठीक नहीं होता, अंदर क्या चलता है?",
        o: [
          ["बैठ कर समझने की कोशिश करता/करती हूँ कि क्या महसूस हो रहा है",                0],
          ["सिस्टम, बॉस, हालात — किसी न किसी पर ग़ुस्सा आता है",                        1],
          ["चुप हो जाता/जाती हूँ, अंदर ही अंदर रख लेता/लेती हूँ",                         2],
          ["आस्तीन चढ़ाकर काम में लग जाता/जाती हूँ",                                    3],
        ] },
      { q: "जिन दिनों काम सबसे भारी लगता है, तब क्या होता है?",
        o: [
          ["एक साफ़-सी उदासी, जिसका नाम मुझे पता है",                                    0],
          ["ऐसे लोगों पर चिढ़ जो अपना हिस्सा नहीं करते",                                1],
          ["धीरे से पीछे हटना — जवाब देना बंद, परवाह कम",                             2],
          ["कुछ भी करने की छटपटाहट, बस उपयोगी लगने के लिए",                            3],
        ] },
      { q: "एक कठिन हफ़्ते के बाद, आप कैसे प्रोसेस करते हैं?",
        o: [
          ["लिखता/लिखती हूँ, टहलता/टहलती हूँ — भावना को आने देता/देती हूँ",              0],
          ["शिकायत करता/करती हूँ — यह सब उचित नहीं था",                                1],
          ["ध्यान भटकाकर अगले हफ़्ते की उम्मीद में डूब जाता/जाती हूँ",                    2],
          ["अगला हफ़्ता घंटों में बाँट देता/देती हूँ",                                    3],
        ] },
    ],
    risk_readiness: [
      { q: "करियर में एक बड़ा क़दम उठाने से आमतौर पर क्या रोकता है?",
        o: [
          ["बिना कोई सुरक्षा जाल के हो सकता है ग़लत निकले",                              0],
          ["ख़ास कुछ नहीं — रास्ते में समझ आ ही जाएगा",                                 1],
          ["अनिश्चितता — मैं आगे की तस्वीर देख ही नहीं पाता/पाती",                       2],
          ["सही समय का इंतज़ार कर रहा/रही हूँ",                                         3],
        ] },
      { q: "अगर कल एक स्थिर नौकरी और एक जोखिम भरा सपना — दोनों सामने आ जाएँ?",
        o: [
          ["स्थिर वाला चुनूँगा/चुनूँगी — मन की शांति ज़रूरी है",                          0],
          ["सपना वाला — यही तो वो पल है",                                             1],
          ["घबरा कर दोनों ही टाल दूँगा/दूँगी",                                          2],
          ["थोड़ा वक़्त लूँगा/लूँगी — देखूँगा/देखूँगी कौन ज़्यादा असली है",                 3],
        ] },
      { q: "बिना गारंटी वाले करियर बदलाव से आपका रिश्ता कैसा है?",
        o: [
          ["पहले थोड़ी सुरक्षा तो चाहिए ही",                                             0],
          ["असुविधा में ही सचमुच का विकास है",                                        1],
          ["न जानना — यही सबसे ज़्यादा तोड़ता है",                                     2],
          ["जब असली रास्ता खुलेगा, मुझे पता चल जाएगा",                                 3],
        ] },
      { q: "जब आपके साथी बड़े क़दम उठाते हैं, आप में क्या जागता है?",
        o: [
          ["चिंता — क्या वे सावधानी बरत रहे हैं?",                                     0],
          ["एक खिंचाव — मैं भी अपना क़दम बहुत रोक चुका/चुकी हूँ",                       1],
          ["बेचैनी — कहीं मैं पीछे न रह जाऊँ",                                          2],
          ["उत्सुकता — पहले देख लूँ कैसे खुलता है उनके लिए",                             3],
        ] },
    ],
    purpose_alignment: [
      { q: "अगर पैसा हमेशा के लिए हल हो जाए, तो भी आप क्या करना चाहेंगे?",
        o: [
          ["कुछ स्थिर, जो मेरे दिन को व्यवस्थित रखे",                                   0],
          ["कुछ ऐसा जिसमें मैं दिखूँ, पहचानी जाऊँ",                                    1],
          ["कुछ स्वतंत्र — कोई बॉस नहीं, कोई शेड्यूल नहीं",                              2],
          ["कुछ जो चुपचाप गहरा हो — कुछ सार्थक बनाना",                                3],
        ] },
      { q: "आपके मौजूदा काम में असल में क्या चीज़ आपको खींचती है?",
        o: [
          ["स्थिरता — ज़िंदगी की योजना बनाई जा सकती है इस पर",                          0],
          ["लोग मुझे देखते हैं, सराहते हैं",                                            1],
          ["अपने अनुसार जीने की जगह",                                                  2],
          ["यह किसी बड़ी चीज़ से जुड़ा हुआ लगता है — सिर्फ़ तनख़्वाह से नहीं",             3],
        ] },
      { q: "दस साल बाद की ज़िंदगी में सबसे ज़्यादा क्या चाहेंगे?",
        o: [
          ["एक बसी हुई, संगठित ज़िंदगी — जिसकी चिंता न हो",                             0],
          ["एक ऐसा नाम जिसे लोग जानें और सम्मान दें",                                 1],
          ["इतनी स्वतंत्रता कि मेरा समय मेरा हो",                                       2],
          ["एक ज़िंदगी जिसका मतलब साफ़ हो",                                          3],
        ] },
      { q: "एक सचमुच अच्छा वर्किंग-डे कैसा दिखता है आपको?",
        o: [
          ["जो प्लान किया था, समय पर हो जाए",                                        0],
          ["किसी ख़ास आदमी ने ग़ौर से मेरा काम देखा",                                   1],
          ["मैं अपनी रफ़्तार से पूरा दिन जिया/जी",                                      2],
          ["लगा कि आज कुछ असली बात आगे बढ़ी",                                        3],
        ] },
    ],
    self_trust: [
      { q: "पेशेवर आलोचना में सबसे गहरी कौन-सी चोट होती है?",
        o: [
          ["कि मैं ठीक से सोच ही नहीं पा रहा/रही",                                       0],
          ["सबके सामने मेरी कमी बताई जाए",                                             1],
          ["कि यह मेरे हाथ में ही नहीं है",                                              2],
          ["कि मैं वह नहीं बन रहा/रही जो बन सकता/सकती थी",                             3],
        ] },
      { q: "करियर के चुनाव के पीछे कौन-सा शांत डर बैठा है?",
        o: [
          ["ग़लत फ़ैसला ले लूँगा/लूँगी और बदल नहीं पाऊँगा/पाऊँगी",                       0],
          ["लोग मुझे देखेंगे और छोटा समझेंगे",                                          1],
          ["मैं अपनी ज़िंदगी का नियंत्रण खो दूँगा/दूँगी",                                 2],
          ["वो काम मुझसे कभी हो ही नहीं पाएगा जो मेरे लिए बना था",                     3],
        ] },
      { q: "पिछली करियर की ग़लती याद आती है, तो सबसे ज़्यादा क्या चुभता है?",
        o: [
          ["कि मुझे पहले ही समझ आना चाहिए था",                                       0],
          ["कि लोगों ने मुझे लड़खड़ाते हुए देखा",                                        1],
          ["कि पल मेरे हाथ से निकल गया",                                             2],
          ["कि मैंने अपने एक बेहतर संस्करण को निराश किया",                             3],
        ] },
      { q: "काम में जो सचमुच चाहिए, उसे कहने से क्या रोकता है?",
        o: [
          ["शायद मैं ही ग़लत हूँ, इसे चाहने में",                                        0],
          ["लोग जज करेंगे",                                                          1],
          ["इसका असर मेरी अभी की ज़िंदगी पर बुरा पड़ेगा",                                2],
          ["अगर यहाँ चूक गया/गई तो और कुछ बड़ा तो है ही नहीं",                        3],
        ] },
    ],
  },

  Relationships: {
    decision_confidence: [
      { q: "जब रिश्ते में कोई असली मोड़ आता है, आप कैसे फ़ैसला करते हैं?",
        o: [
          ["मैं बीते वक़्त के पैटर्न, संकेत — सब देखने लगता/लगती हूँ",                     0],
          ["भीतर से पता चल जाता है — शरीर पहले, मन बाद में",                          1],
          ["एक-दो अपनों से पूछता/पूछती हूँ जिन्हें मैं पता हूँ",                          2],
          ["वक़्त पर छोड़ देता/देती हूँ",                                                3],
        ] },
      { q: "अगर 30 दिन में जाना या रुकना तय करना पड़े?",
        o: [
          ["सब भावनाओं की सूची बनाकर साफ़ देखने की कोशिश करूँगा/करूँगी",                 0],
          ["अंदर से जवाब पता है — मैं उसे टाल रहा/रही हूँ",                              1],
          ["किसी अपने से सुनना चाहूँगा/चाहूँगी पहले",                                    2],
          ["शायद रुक जाऊँ और उम्मीद करूँ कि फ़ैसला ख़ुद हो जाए",                          3],
        ] },
      { q: "जब प्यार उलझ जाता है, इसके बाद क्या होता है?",
        o: [
          ["हम दोनों के बीच का पैटर्न समझने की कोशिश करता/करती हूँ",                     0],
          ["भावना के पीछे चलता/चलती हूँ — अंदर की आवाज़ मुझे धोखा नहीं देती",             1],
          ["किसी दोस्त से बात करके ही समझ पाता/पाती हूँ मेरा असल क्या है",                2],
          ["पूरे मामले को दराज़ में रख देता/देती हूँ",                                    3],
        ] },
      { q: "किस पर भरोसा करना है — यह कैसे तय करते हैं?",
        o: [
          ["धीरे-धीरे — मैं वक़्त के साथ काम देखता/देखती हूँ",                             0],
          ["बहुत जल्दी — मैं लोगों को लगभग तुरंत भाँप लेता/लेती हूँ",                     1],
          ["जो मुझे सबसे अच्छा जानते हैं, उनसे पूछता/पूछती हूँ",                          2],
          ["तय ही नहीं करता/करती — सतर्क रहता/रहती हूँ, सामने वाले को साबित करने देता/देती हूँ",3],
        ] },
    ],
    emotional_clarity: [
      { q: "जब कोई प्यारा आपसे भावनात्मक रूप से दूर होने लगे, तो सबसे ज़्यादा क्या दुखता है?",
        o: [
          ["वो सुरक्षा का एहसास खोना जो मुझे था",                                       0],
          ["कि उन्होंने अपनी दुनिया मेरे साथ बाँटना बंद कर दिया",                        1],
          ["कि मुझे पता ही नहीं क्या ग़लत किया",                                        2],
          ["कि मैं आसानी से बदले जा सकने वाला/वाली महसूस होने लगा/लगी",                3],
        ] },
      { q: "क़रीबी से गुस्सा आए, तो पहले क्या करते हैं?",
        o: [
          ["पीछे हट कर समझने की कोशिश कि मुझे क्या हो रहा है",                          0],
          ["तुरंत सामने आकर बात करता/करती हूँ",                                        1],
          ["दिखाता/दिखाती हूँ कि सब ठीक है — जब तक फूट न पड़े",                        2],
          ["कुछ ठोस करता/करती हूँ — लिखता/लिखती हूँ, टहलता/टहलती हूँ, किसी को फ़ोन",     3],
        ] },
      { q: "किसी झगड़े के बाद अंदर क्या होता है?",
        o: [
          ["चुप रहता/रहती हूँ — मुझे उसे पूरा महसूस करने का वक़्त चाहिए",                    0],
          ["उनकी ग़लती बार-बार दिमाग़ में दोहराता/दोहराती हूँ",                            1],
          ["ठंडा हो जाता/जाती हूँ — गर्मजोशी कुछ दिनों तक बंद",                          2],
          ["सुधार की तरफ़ बढ़ता/बढ़ती हूँ — माफ़ी, इशारा, कुछ करना",                    3],
        ] },
      { q: "साथी या दोस्त की चुप्पी को आप कैसे संभालते हैं?",
        o: [
          ["नाम देने की कोशिश करता/करती हूँ — क्या है यह, दर्द, डर, चिंता",              0],
          ["तेज़ हो जाता/जाती हूँ — यह चुप्पी उचित नहीं",                                1],
          ["उतनी ही चुप्पी लौटा देता/देती हूँ",                                          2],
          ["पहले मैं ही आगे बढ़ता/बढ़ती हूँ, नरमी से — देखने कि नीचे क्या है",              3],
        ] },
    ],
    risk_readiness: [
      { q: "दिल खोलने के मामले में सबसे सच क्या लगता है?",
        o: [
          ["प्यार चाहिए, पर सुरक्षित लगे तभी",                                          0],
          ["चोट खा लूँगा/लूँगी, पर पूरी तरह महसूस करना चाहता/चाहती हूँ",                  1],
          ["पीछे रह जाता/जाती हूँ — किसी के बारे में ग़लत होना डराता है",                 2],
          ["जब पल सही लगे तभी खुलता/खुलती हूँ, उससे पहले नहीं",                          3],
        ] },
      { q: "नए इंसान के सामने कमज़ोर पड़ना — आपके लिए कैसा है?",
        o: [
          ["धीरे-धीरे बाँटता/बाँटती हूँ — बस उतना जो खो जाए तो सह लूँ",                  0],
          ["पूरा खुलता/खुलती हूँ — सुरक्षा ईमानदारी से आती है, सावधानी से नहीं",           1],
          ["इससे बचता/बचती हूँ — देखा जाना अकेले होने से ज़्यादा डराता है",                 2],
          ["अपने आप खुलने देता/देती हूँ — सही गहराई सही समय पर आती है",                 3],
        ] },
      { q: "साथी अगर एक बड़ा जीवन बदलाव सुझाए, आपकी पहली प्रतिक्रिया?",
        o: [
          ["हाँ कहने से पहले साफ़ प्लान चाहिए",                                         0],
          ["हाँ — फैलते हैं, बढ़ते हैं, करते हैं",                                        1],
          ["सुन्न पड़ जाऊँगा/जाऊँगी — इतनी अनिश्चितता एक बार में नहीं संभल पाती",         2],
          ["थोड़ा वक़्त लें, अगर तब भी लगे तो हाँ",                                     3],
        ] },
      { q: "प्रेम में कौन-सा जोखिम सबसे कठिन है?",
        o: [
          ["जिसमें मेरी बनाई हुई स्थिरता टूट सकती है",                                   0],
          ["जिसमें मैं कुछ भी नहीं छिपाऊँ और फिर भी ठुकराया जाऊँ",                       1],
          ["कोई भी — प्रेम में अनिश्चितता मुझे सबसे थकाती है",                            2],
          ["समय आने से पहले जल्दबाज़ी में क़दम उठाना",                                   3],
        ] },
    ],
    purpose_alignment: [
      { q: "दिल में गहरे, आप रिश्ते से क्या माँगते हैं?",
        o: [
          ["घर जैसा एहसास — जिस पर अपनी पूरी ज़िंदगी टिका सकूँ",                          0],
          ["सचमुच देखे जाने का, चुने जाने का एहसास — बस सहा जाना नहीं",                  1],
          ["इतनी जगह कि मैं प्यार में भी अपना/अपनी बना/बनी रहूँ",                        2],
          ["एक साझा मक़सद — कि हमने साथ में कुछ असली बनाया",                            3],
        ] },
      { q: "अपने सबसे क़रीबी रिश्तों में असल में क्या चाहिए?",
        o: [
          ["स्थिरता — कल भी वहीं होंगे, यह पता होना चाहिए",                             0],
          ["सराहा जाना, चुना जाना, किसी की नज़र में ऊँचा उठाया जाना",                    1],
          ["हवा — बिना प्रदर्शन के, बिना दबाव के",                                     2],
          ["एक साझेदारी जो हम दोनों से बड़ी हो",                                       3],
        ] },
      { q: "प्रेम कैसा होना चाहिए — किस पंक्ति में जान है?",
        o: [
          ["एक शरण",                                                                 0],
          ["एक मंच — जहाँ मैं ज़ोर से चाहा/चाही जाता/जाती हूँ",                          1],
          ["एक बगीचा — जहाँ मैं अकेले भी बढ़ता/बढ़ती हूँ",                              2],
          ["एक शांत वादा — कि हम मिलकर मायने बना रहे हैं",                            3],
        ] },
      { q: "अगर जीवन में अब बस एक रिश्ता बचे, तो वो कैसा हो?",
        o: [
          ["वो जो दुनिया के न संभालने पर मुझे संभाले",                                   0],
          ["वो जिसमें मैं हर दिन चाहा/चाही जाता/जाती हूँ",                                1],
          ["वो जिसमें मुझे कभी सिकुड़ना नहीं पड़े",                                       2],
          ["वो जो हम दोनों की ज़िंदगी को अर्थ दे",                                       3],
        ] },
    ],
    self_trust: [
      { q: "प्रेम में सबसे ज़्यादा कौन-सी भावना डराती है?",
        o: [
          ["छोड़ दिए जाने का",                                                        0],
          ["ग़लत समझे जाने का",                                                      1],
          ["नियंत्रित किए जाने का",                                                    2],
          ["सही इंसान न मिल पाने का",                                                 3],
        ] },
      { q: "अगर एक रिश्ते की बातचीत दोबारा कर सकें, तो क्या बदलेंगे?",
        o: [
          ["जो मैंने कहा — वो ठीक से नहीं निकला",                                      0],
          ["जो मैंने नहीं कहा — मैं छोटा/छोटी रह गया/गयी",                                1],
          ["वो व्यक्ति जिसे मैंने कहा",                                                  2],
          ["कुछ नहीं — पर मैं आज भी इसे दोहराता/दोहराती हूँ, कुछ तो है इसमें",           3],
        ] },
      { q: "प्रेम में जो सच चाहिए, वो माँगने से क्या रोकता है?",
        o: [
          ["शायद मैं ही ग़लत हूँ, यह चाहने में",                                          0],
          ["वो मुझे कमज़ोर, कमतर देखने लगेंगे",                                          1],
          ["हम दोनों के बीच का जो संतुलन है, वो बदल जाएगा",                            2],
          ["अगर उन्होंने मना कर दिया, तो अंदर का एक हिस्सा फिर कभी नहीं पूछेगा",           3],
        ] },
      { q: "प्रेम की शैली को कौन-सा शांत डर आकार देता है?",
        o: [
          ["कि मैं ग़लत चुनूँगा/चुनूँगी और साल बरबाद हो जाएँगे",                          0],
          ["कि जो मैं छिपाता/छिपाती हूँ, वो देख लेंगे",                                   1],
          ["कि प्यार में अपना एक हिस्सा देना पड़ेगा",                                    2],
          ["कि मैं कभी वैसे प्यार नहीं कर पाऊँगा/पाऊँगी जैसे कर सकता/सकती थी",           3],
        ] },
    ],
  },

  Money: {
    decision_confidence: [
      { q: "जब कोई असली आर्थिक फ़ैसला सामने आता है, पहले क्या होता है?",
        o: [
          ["स्प्रेडशीट खोलता/खोलती हूँ — नंबरों के बिना कोई बड़ा क़दम नहीं",              0],
          ["अंदर से पहले ही हाँ/ना पता चल जाता है",                                      1],
          ["ऐसे किसी से पूछता/पूछती हूँ जो पैसे को बेहतर समझता है",                     2],
          ["बैठा रहता/रहती हूँ — फ़ैसला अपने आप बन जाएगा",                              3],
        ] },
      { q: "आपका पिछला बड़ा वित्तीय फ़ैसला असल में कैसे हुआ था?",
        o: [
          ["शोध, तुलना, तनाव-परीक्षण",                                                0],
          ["सही लगा — मेरे लिए बस इतना काफ़ी था",                                      1],
          ["किसी अपने ने मेरी मदद की तय करने में",                                    2],
          ["सच कहूँ तो — डेडलाइन ने मेरे लिए तय किया",                                3],
        ] },
      { q: "बड़ी ख़रीदी या निवेश आप कैसे करते हैं?",
        o: [
          ["धीरे-धीरे, गणित के साथ, कई हफ़्तों में",                                     0],
          ["जल्दी — जब पल सही लगता है",                                              1],
          ["पहले सलाहकार या घरवाले से पूछता/पूछती हूँ",                                2],
          ["टालता/टालती हूँ — और अक्सर मौक़ा निकल जाता है",                            3],
        ] },
      { q: "अगर कोई मुनाफ़े का पर अनजान अवसर आज सामने आ जाए?",
        o: [
          ["हफ़्तों तक जाँचूँगा/जाँचूँगी, फिर छूऊँगा/छूऊँगी",                            0],
          ["अगर आकृति सही लगी, तो तेज़ी से क़दम बढ़ाऊँगा/बढ़ाऊँगी",                    1],
          ["किसी ज़्यादा समझदार को भेज दूँगा/दूँगी उनकी राय के लिए",                     2],
          ["सोचूँगा/सोचूँगी और चुपचाप जाने दूँगा/दूँगी",                                3],
        ] },
    ],
    emotional_clarity: [
      { q: "पैसे के बारे में सोचते वक़्त सबसे ज़्यादा कौन-सी भावना उठती है?",
        o: [
          ["एक शांत ज़िम्मेदारी — मुझे पता है यह मेरे कंधों पर है",                       0],
          ["चिढ़ — मुझे कम मिला है",                                                    1],
          ["बेचैनी — मैं इससे बचता/बचती हूँ जितना हो सके",                              2],
          ["एक शांत उत्साह — मैं बनाने के लिए तैयार हूँ",                                3],
        ] },
      { q: "जब पैसे के मामले उल्टे पड़ते हैं, आप में क्या होता है?",
        o: [
          ["बैठकर समझने की कोशिश कि यह असल में किस बारे में है",                        0],
          ["बाज़ार, नौकरी, समय — किसी न किसी को दोष देता/देती हूँ",                     1],
          ["चुप हो जाता/जाती हूँ — कुछ हफ़्ते खाता ही नहीं देखता/देखती",                 2],
          ["उसी दिन योजना बनाता/बनाती हूँ — ठीक करने की",                              3],
        ] },
      { q: "पैसे से आपका रिश्ता किस पंक्ति में सबसे सच लगता है?",
        o: [
          ["एक बोझ — जिसे मैं होश में, पर शांति से उठाता/उठाती हूँ",                     0],
          ["एक झुँझलाहट भरी चीज़ जो कभी सही नहीं बैठती",                                1],
          ["एक ऐसा विषय जिससे मैं चुपचाप दूर रहता/रहती हूँ",                             2],
          ["एक उपकरण — मैं इसे अच्छे से इस्तेमाल करना सीख रहा/रही हूँ",                  3],
        ] },
      { q: "कोई और जब पैसे की बात छेड़ता है, कैसा लगता है?",
        o: [
          ["उत्सुकता — मैं ख़ुद के रिश्ते को बेहतर समझना चाहता/चाहती हूँ",                 0],
          ["आँकी जाती हूँ ऐसा लगता है",                                                1],
          ["असहज — बात बदल देता/देती हूँ",                                            2],
          ["ज़मीन पर — मैं जानता/जानती हूँ मैं कहाँ खड़ा/खड़ी हूँ",                     3],
        ] },
    ],
    risk_readiness: [
      { q: "अभी आपके लिए कितना वित्तीय जोखिम सेहतमंद लगता है?",
        o: [
          ["लगभग कुछ नहीं — मुझे सब कुछ सुरक्षित चाहिए",                                0],
          ["ठीक-ठाक जोखिम — सुरक्षित डिब्बे में कुछ नहीं बढ़ता",                          1],
          ["मैं जोखिम से बचता/बचती हूँ — यह न-जानना मैं झेल नहीं पाता/पाती",             2],
          ["सही समय, सही मात्रा वाला जोखिम",                                          3],
        ] },
      { q: "कल अगर अतिरिक्त पैसा आ जाए, कहाँ जाएगा?",
        o: [
          ["सीधे बचत में, सुरक्षा में",                                                  0],
          ["कहीं ऐसा जो कई गुना हो सकता है, भले न हो",                                 1],
          ["कहीं नहीं — मैं महीनों सोचूँगा/सोचूँगी",                                      2],
          ["एक ऐसी जगह जिसे मैं देर से देख रहा/रही हूँ",                                3],
        ] },
      { q: "अपना कुछ शुरू करने के बारे में आप कैसे सोचते हैं?",
        o: [
          ["पहले बहुत मज़बूत सुरक्षा जाल चाहिए",                                          0],
          ["छलाँग लगाऊँगा/लगाऊँगी — असली धन ऐसे ही बनता है",                          1],
          ["अनिश्चितता ही मुझे शुरू करने से रोकती है",                                   2],
          ["सही पल आया, तो बात साफ़ हो जाएगी",                                        3],
        ] },
      { q: "अगर कोई हाई-अपसाइड जोखिम भरा निवेश सुझाए?",
        o: [
          ["नहीं — मुझे संरक्षण चाहिए, संभावना नहीं",                                    0],
          ["देखूँगा/देखूँगी, अगर आँकड़े ईमानदार हैं, तो हाँ",                             1],
          ["ना — मेरी नसें इसे नहीं झेल पाएँगी",                                          2],
          ["बाज़ार से पल का इशारा आने का इंतज़ार करूँगा/करूँगी",                          3],
        ] },
    ],
    purpose_alignment: [
      { q: "अगर कल आर्थिक रूप से मुक्त हो जाएँ, सबसे पहले क्या बदलेगा?",
        o: [
          ["मन की शांति — आख़िर मैं साँस ले पाऊँगा/पाऊँगी",                            0],
          ["मेरी उपस्थिति — मुझे अपने पूरे रूप में देखा जाएगा",                          1],
          ["मेरा समय — मैं पूरी तरह अपना मालिक/मालकिन हो जाऊँगा/जाऊँगी",             2],
          ["मेरा काम — सिर्फ़ वही चुनूँगा/चुनूँगी जो सार्थक हो",                          3],
        ] },
      { q: "'बस, अब काफ़ी है' — आपके लिए इसका असली मतलब क्या है?",
        o: [
          ["सुरक्षा — जिसे लेकर मुझे चिंता न रहे",                                       0],
          ["जो मैंने बनाया, उसके लिए मुझे पहचाना जाना",                                 1],
          ["स्वतंत्रता — किसी के आगे जवाबदेह न रहना",                                   2],
          ["जब पैसा मेरे अर्थ से मेल खाता है",                                          3],
        ] },
      { q: "बचपन में पैसे के बारे में कौन-सी बात आप पर सबसे गहरी बैठी?",
        o: [
          ["पैसा कमाना मुश्किल है — मिले तो संभालकर रखो",                              0],
          ["पैसा सम्मान लाता है — मिलने पर लोग नज़र में लेते हैं",                        1],
          ["पैसा आज़ादी देता है — मैं किसी का बंधुआ नहीं होना चाहता/चाहती",             2],
          ["पैसा एक साधन है — असली बात अर्थ है",                                     3],
        ] },
      { q: "आप असल में किसकी तरफ़ बढ़ रहे हैं अपने पैसे से?",
        o: [
          ["एक नर्म, सुरक्षित ज़िंदगी की",                                              0],
          ["ऐसी ज़िंदगी जिसे लोग देखें",                                                1],
          ["ऐसी आज़ादी जिसमें मैं जो न चाहूँ, छोड़ सकूँ",                                 2],
          ["एक ऐसी ज़िंदगी जिसके नंबर मेरे असली रूप से मेल खाते हों",                     3],
        ] },
    ],
    self_trust: [
      { q: "पैसे की किस ग़लती का सबसे बड़ा अफ़सोस है?",
        o: [
          ["ग़लत आदमी/जानकारी पर भरोसा कर लिया",                                        0],
          ["नुक़सान सबके सामने दिख गया",                                                1],
          ["नियंत्रण छूट गया — पैसा मुझसे बिना, मेरे बिना चलने लगा",                     2],
          ["एक जोखिम नहीं लिया — जो शायद सब कुछ बदल देता",                             3],
        ] },
      { q: "अगर कल ज़्यादातर बचत खो जाए, सबसे ज़्यादा क्या चुभेगा?",
        o: [
          ["सावधानी बरत लेता/लेती तो शायद बच जाता",                                    0],
          ["अब लोग मुझे अलग नज़रों से देखेंगे",                                         1],
          ["मेरी स्वतंत्रता मेरे हाथ से फिसल जाएगी",                                     2],
          ["जो भविष्य मैं बना रहा/रही थी, वो सब पिघल जाएगा",                            3],
        ] },
      { q: "पैसे के जो क़दम आप उठाना चाहते हैं, उनसे क्या रोकता है?",
        o: [
          ["ग़लत हो सकता है — मुझे अपने पर पूरा भरोसा नहीं",                             0],
          ["अगर न चला, तो लोग आँकेंगे",                                                1],
          ["इस ज़िंदगी की स्थिरता ख़तरे में पड़ सकती है",                                 2],
          ["अगर यहाँ चूक गया/गयी, तो जो भविष्य बनाना था वो नहीं बनेगा",                 3],
        ] },
      { q: "पैसा आपके लिए इतना भारी क्यों लगता है?",
        o: [
          ["क्योंकि इसमें मुझे अपने पर पूरा भरोसा नहीं है",                                 0],
          ["क्योंकि यह जुड़ा है इससे कि दुनिया मुझे कैसे देखती है",                        1],
          ["क्योंकि एक बार मैं इसकी लगाम खो चुका/चुकी हूँ",                              2],
          ["क्योंकि यह तय करता है कि मैं जो बन सकता/सकती हूँ वो बन पाऊँगा/पाऊँगी या नहीं",3],
        ] },
    ],
  },

  Family: {
    decision_confidence: [
      { q: "जब कोई कठिन पारिवारिक फ़ैसला आता है, अंदर क्या होता है?",
        o: [
          ["सोचता/सोचती हूँ — सबके लिए क्या सही है, बोलने से पहले",                       0],
          ["अंदर से मुझे पहले ही पता है क्या होना चाहिए",                                 1],
          ["तय करने से पहले किसी भाई/बहन/क़रीबी से पूछता/पूछती हूँ",                     2],
          ["देखता/देखती हूँ पहले परिवार क्या तय करता है",                                3],
        ] },
      { q: "पारिवारिक फ़ैसलों में सबसे ज़्यादा किस पर भरोसा करते हैं?",
        o: [
          ["अपने दिमाग़ पर — मैं ध्यान से सोचता/सोचती हूँ",                             0],
          ["अपने गट पर — शरीर मन से पहले जान लेता है",                                 1],
          ["परिवार के उस एक इंसान पर जो सच जानता है",                                 2],
          ["किसी पर नहीं — जब तक हालात मजबूर न कर दें, टालता/टालती हूँ",                3],
        ] },
      { q: "पिछले बड़े पारिवारिक फ़ैसले में आपने क्या किया था?",
        o: [
          ["तथ्य जुटाए, सोचा, फिर बात की",                                            0],
          ["वो कहा जो मुझे सच लगा — भले कठिन था",                                     1],
          ["ज़्यादातर सुना और परिवार के साथ चला/चली",                                  2],
          ["चुप रह गया/गयी — जो हुआ, मेरे बग़ैर हुआ",                                    3],
        ] },
      { q: "जब परिवार एक चाहे और आपका दिल दूसरा — तब कैसे तय करते हैं?",
        o: [
          ["दोनों को तौलता/तौलती हूँ — मेरा सच बड़ा है या उनकी शांति?",                   0],
          ["भीतर के खिंचाव के पीछे चलता/चलती हूँ, भले उन्हें कुछ देर दुख हो",              1],
          ["किसी पर टिकता/टिकती हूँ जो मुझे और परिवार दोनों को समझे",                    2],
          ["उनका मानकर चलता/चलती हूँ — अभी के लिए — और भीतर टीसता/टीसती हूँ",         3],
        ] },
    ],
    emotional_clarity: [
      { q: "परिवार के रिश्तों में सबसे ज़्यादा क्या दुखता है?",
        o: [
          ["अनदेखा किया जाना — जबकि मैं इतना कुछ कर रहा/रही हूँ",                       0],
          ["लगातार आलोचना — मेरा कुछ भी सही नहीं",                                    1],
          ["धीरे-धीरे बढ़ती दूरी — जिस पर कोई बात नहीं करता",                            2],
          ["ऐसी ज़िम्मेदारियाँ जो मैंने कभी हामी नहीं भरी थीं",                            3],
        ] },
      { q: "पारिवारिक झगड़ा होने पर आप आमतौर पर क्या करते हैं?",
        o: [
          ["समझने की कोशिश — असल में सब किससे डर रहे हैं",                             0],
          ["अपनी बात लड़ता/लड़ती हूँ — किसी को तो सच कहना है",                          1],
          ["चुप रहता/रहती हूँ — तूफ़ान गुज़र जाने की उम्मीद में",                          2],
          ["बीच में आकर सबको एक साथ जोड़ने की कोशिश करता/करती हूँ",                    3],
        ] },
      { q: "जब कोई परिवार वाला चोट पहुँचाए, कैसा प्रतिकार करते हैं?",
        o: [
          ["बैठ कर समझता/समझती हूँ — इतनी चोट क्यों?",                                 0],
          ["तेज़ हो जाता/जाती हूँ — जान-बूझकर किया था",                                1],
          ["ठंडा हो जाता/जाती हूँ — बिना कहे दूरी बना लेता/लेती हूँ",                    2],
          ["सुधार पर ध्यान — शांति दर्द से पहले चाहिए",                                 3],
        ] },
      { q: "बचपन के परिवार से आज तक क्या साथ चलता है?",
        o: [
          ["एक साफ़ पहचान — मुझे पता है मैंने क्या महसूस किया, भले किसी ने न पूछा",         0],
          ["एक शांत ग़ुस्सा — जो हुआ, वो ठीक नहीं था",                                  1],
          ["सिकुड़ने की आदत — कहीं कोई शोर न हो",                                       2],
          ["सबको जोड़े रखने की क्षमता",                                                3],
        ] },
    ],
    risk_readiness: [
      { q: "जो आप सचमुच चाहते हैं, उसके लिए परिवार को निराश करना — कैसा लगता है?",
        o: [
          ["उनकी शांति चुनूँगा/चुनूँगी — मुझे उनकी स्थिरता चाहिए",                       0],
          ["निराश कर दूँगा/दूँगी — यह ज़िंदगी मेरी है",                                 1],
          ["सोचते ही अंदर जम जाता/जाती हूँ",                                            2],
          ["सही मौसम का इंतज़ार करूँगा/करूँगी — तब कहूँगा/कहूँगी",                       3],
        ] },
      { q: "अगर परिवार आपके सपने का पूरी तरह विरोध करे, तो?",
        o: [
          ["सपना बंद कर दूँगा/दूँगी — परिवार पहले",                                    0],
          ["करता/करती रहूँगा/रहूँगी — वे समय के साथ समझ जाएँगे",                        1],
          ["छोड़ दूँगा/दूँगी — इतना तनाव नहीं झेलूँगा/झेलूँगी",                          2],
          ["छोटे, चुपचाप क़दम उठाऊँगा/उठाऊँगी जब तक कि तनाव पिघले",                     3],
        ] },
      { q: "पारिवारिक परंपरा या अपेक्षा के ख़िलाफ़ जाना — कैसा है आपके लिए?",
        o: [
          ["असहज — परंपरा से ही तो सुरक्षा है",                                          0],
          ["तैयार — मेरी ज़िंदगी पर पैटर्न से ज़्यादा हक़ है",                              1],
          ["डरावना — बिना उस ढाँचे के मैं कौन हूँ, नहीं पता",                            2],
          ["सोच-समझकर — सही खिड़की खुले तब तोड़ूँगा/तोड़ूँगी",                         3],
        ] },
      { q: "अपनी कितनी ज़िंदगी परिवार से छुपाकर रखते हैं?",
        o: [
          ["बहुत कम — किसी को चौंकाना सुरक्षित नहीं",                                   0],
          ["बहुत — मैंने आराम से नहीं, सच्चाई से जीना चुना है",                          1],
          ["असली सब कुछ — उनकी प्रतिक्रिया झेल नहीं सकता/सकती",                        2],
          ["कुछ बातें — जब तक सही पल न आए",                                          3],
        ] },
    ],
    purpose_alignment: [
      { q: "अगर परिवार से एक वाक्य सुन सकते, तो कौन-सा?",
        o: [
          ["'हम यहाँ हैं। यह बोझ अकेले नहीं ढोना है।'",                                   0],
          ["'हमें तुम पर गर्व है।'",                                                    1],
          ["'हम पर कोई क़र्ज़ नहीं है — अपनी ज़िंदगी जियो।'",                             2],
          ["'तुम सही थे/थीं — जो तुम बने/बनीं, वो सही है।'",                             3],
        ] },
      { q: "परिवार में आप कौन-सी भूमिका अक्सर निभाते हैं?",
        o: [
          ["ज़िम्मेदार वाला — जिस पर पूरा बोझ है",                                       0],
          ["जिससे सबको गर्व होना है",                                                  1],
          ["वो जिसने चुपचाप अपनी स्वतंत्रता बचाई",                                       2],
          ["वो जो परिवार की स्क्रिप्ट से बड़ा बनने की कोशिश में है",                       3],
        ] },
      { q: "परिवार का जीवन आप में कैसा एहसास जगाए — यह चाहते हैं?",
        o: [
          ["स्थिर, भरोसेमंद, सुरक्षित",                                                  0],
          ["जहाँ मुझे सराहा जाए, जैसा मैं हूँ",                                          1],
          ["जहाँ मैं बिना दायित्व के लौट सकूँ",                                         2],
          ["जहाँ हम सबकी ज़िंदगी मिलकर कुछ मायने रखती हो",                              3],
        ] },
      { q: "परिवार को इंसान को क्या देना चाहिए?",
        o: [
          ["एक नरम जगह गिरने के लिए",                                                  0],
          ["एक आईना जो कहे — 'तुम यहाँ ज़रूरी हो'",                                     1],
          ["साँस लेने और अलग होकर बढ़ने की जगह",                                       2],
          ["एक साझी कहानी — जो सालों के पार जाए",                                     3],
        ] },
    ],
    self_trust: [
      { q: "परिवार की किस अपेक्षा ने आपकी ज़िंदगी पर सबसे ज़्यादा असर डाला?",
        o: [
          ["करियर की — कि 'सही' ज़िंदगी बनानी है",                                     0],
          ["'अच्छा बेटा/बेटी' कैसा दिखना चाहिए, इसकी",                                 1],
          ["वो भावनात्मक ज़िम्मेदारियाँ जिनसे मैं कभी बच नहीं सका/सकी",                   2],
          ["कि मैं उससे बड़ा/बड़ी बनूँगा/बनूँगी जितना वो बन सके थे",                     3],
        ] },
      { q: "पारिवारिक फ़ैसलों के नीचे कौन-सा शांत डर बहता है?",
        o: [
          ["कि मेरा एक क़दम परिवार को तोड़ देगा",                                       0],
          ["कि मुझे देख कर वे मुझे कमतर आँकने लगेंगे",                                    1],
          ["कि मैं अपनी ज़िंदगी की लगाम खो दूँगा/दूँगी",                                 2],
          ["कि मैं कभी अपना/अपनी असली रूप बने बग़ैर नहीं जी पाऊँगा/पाऊँगी",             3],
        ] },
      { q: "जो सच में लगता है, उसे परिवार से कहने से क्या रोकता है?",
        o: [
          ["कहीं मैं ग़लत तो नहीं — कहा हुआ वापस नहीं होगा",                              0],
          ["वे मुझे नाशुक्रा/ड्रामाबाज़ न समझ बैठें",                                     1],
          ["जो व्यवस्था बनी है, वो टूट जाएगी",                                          2],
          ["अगर उन्होंने मेरा सच नहीं झेला, तो हम एक-दूसरे को खो देंगे",                   3],
        ] },
      { q: "परिवार के लिए आप क्या बनना बंद करना चाहते हैं?",
        o: [
          ["वो जो हमेशा सोच-समझकर बोलता/बोलती है",                                    0],
          ["वो जो उन्हें हमेशा अच्छा दिखाता/दिखाती है",                                 1],
          ["वो जो सबको जोड़े रखता/रखती है",                                            2],
          ["वो जो हमेशा बनते-बनते रह गया/गयी, कभी बना/बनी नहीं",                        3],
        ] },
    ],
  },

  Purpose: {
    decision_confidence: [
      { q: "जब जीवन-दिशा बदलने का इशारा आता है, कैसे प्रतिक्रिया देते हैं?",
        o: [
          ["बैठकर योजना बनाता/बनाती हूँ — अर्थ को भी ढाँचा चाहिए",                       0],
          ["उसके पीछे चलता/चलती हूँ — मेरी अंदर की सुई शायद ही ग़लत हो",                 1],
          ["गुरु या भरोसेमंद दोस्त से बात करता/करती हूँ",                                2],
          ["इंतज़ार करता/करती हूँ — शायद यह खिंचाव या तो हट जाए या साफ़ हो",             3],
        ] },
      { q: "जीवन-दिशा के फ़ैसले आमतौर पर कैसे लेते हैं?",
        o: [
          ["धीरे, विधिवत — भविष्य को जल्दी में तय नहीं किया जाता",                       0],
          ["तेज़ी से, जब जवाब शरीर तक आ जाता है",                                       1],
          ["ऐसी बातचीतों से जो मुझे ख़ुद को सुनने में मदद करती हैं",                       2],
          ["सच कहूँ तो — ज़िंदगी ख़ुद चुनती रहती है मेरे लिए",                            3],
        ] },
      { q: "जब भीतर की आवाज़ कहे कि यह ज़िंदगी तुम्हारी नहीं है?",
        o: [
          ["उसे परखता/परखती हूँ — असली है या बस थका हुआ हफ़्ता?",                         0],
          ["उस पर भरोसा करता/करती हूँ — यह आवाज़ पहले कभी ग़लत नहीं थी",                1],
          ["जो मुझे जानते हैं, उनसे पूछता/पूछती हूँ कि क्या उन्हें भी दिखता है",             2],
          ["अनदेखा करता/करती हूँ — शायद अपने आप चली जाए",                             3],
        ] },
      { q: "अभी 'हाँ' या 'ना' कहने में कैसे तय करते हैं?",
        o: [
          ["गहरे सोचकर — यह मेरे लिए क्या है?",                                          0],
          ["अंदर के इशारे से — या तो सच्चा 'हाँ' है, या नहीं",                             1],
          ["देखता/देखती हूँ कि मेरे अपनों को क्या लगता है",                              2],
          ["आमतौर पर हाँ कह देता/देती हूँ, बाक़ी बाद में देखूँगा/देखूँगी",                 3],
        ] },
    ],
    emotional_clarity: [
      { q: "देर रात कौन-सा ख़्याल सबसे अक्सर आता है?",
        o: [
          ["इतना कुछ के बाद भी अधूरा क्यों लगता है?",                                    0],
          ["क्या मैं ज़िंदगी उन चीज़ों में बहा रहा/रही हूँ जो मेरी हैं ही नहीं?",           1],
          ["क्या बस यही सब है?",                                                        2],
          ["मैं यहाँ असल में करने क्या आया/आयी हूँ?",                                    3],
        ] },
      { q: "जब रास्ता अस्पष्ट लगे, तो भीतर क्या होता है?",
        o: [
          ["अंदर मुड़ता/मुड़ती हूँ — क्या हो रहा है, नाम देने की कोशिश",                    0],
          ["व्यवस्था, दुनिया, समय — सब पर चिढ़ जाती है",                                1],
          ["चुप हो जाता/जाती हूँ — सपने ज़ोर से बोलना बंद कर देता/देती हूँ",             2],
          ["चलता/चलती रहता/रहती हूँ — गति ही कुछ दिखाएगी",                            3],
        ] },
      { q: "इन दिनों आपकी ज़िंदगी का भाव-मौसम कैसा है?",
        o: [
          ["एक शांत, ईमानदार उदासी — जिससे भाग नहीं रहा/रही",                          0],
          ["एक बेचैनी — जिसे ठीक से दिशा नहीं दे पा रहा/रही",                            1],
          ["एक शांत सुन्नपन — बहुत कुछ महसूस नहीं होता",                                 2],
          ["एक सुबह की शांति — कुछ करवट ले रहा है",                                    3],
        ] },
      { q: "कैसे पता चलता है कि आपकी ज़िंदगी लय से बाहर है?",
        o: [
          ["शरीर पहले बताता है, बाद में और सब",                                         0],
          ["आस-पास सब कुछ चिढ़ाने लगता है",                                             1],
          ["जो पहले पसंद था, अब वो भी बेस्वाद लगता है",                                 2],
          ["एक नया खिंचाव आता है — जिसे टाल नहीं पाता/पाती",                            3],
        ] },
    ],
    risk_readiness: [
      { q: "पूरी ज़िंदगी की शक्ल बदलने के लिए कितने तैयार हैं?",
        o: [
          ["सावधान — मैं बदलाव चाहता/चाहती हूँ पर जो बना है वो बचा रहे",                 0],
          ["तैयार — मैं मानो अनुमति का इंतज़ार कर रहा/रही थी",                            1],
          ["तैयार नहीं — अनिश्चितता डराती है",                                            2],
          ["सजग — सही खिड़की खुलेगी",                                                   3],
        ] },
      { q: "अगर कोई आपको आँके ही नहीं — तो सचमुच क्या करेंगे?",
        o: [
          ["कुछ स्थिर — जो अभी की ज़िंदगी में फ़िट हो",                                 0],
          ["एक सपना — जिसके बारे में मैं चुप रहा/रही हूँ",                                1],
          ["कुछ आध्यात्मिक, भीतरी — जिसे मैंने कभी ज़ोर से नहीं कहा",                     2],
          ["कुछ रोमांचक — मैं जोखिम उठाऊँगा/उठाऊँगी जितना पहले कभी नहीं",                3],
        ] },
      { q: "जब सब बदलने की कल्पना करते हैं, शरीर कैसा महसूस करता है?",
        o: [
          ["सिकुड़ता है — जो पता है उसे बचाना है",                                        0],
          ["जाग जाता है — यही वो दिशा है जिससे मैं बचता/बचती रही/रहा",                   1],
          ["ठिठक जाता है — बाद की तस्वीर बन ही नहीं पाती",                              2],
          ["शांत — यह आ रहा है, बस आज नहीं",                                          3],
        ] },
      { q: "जोखिम पर कौन-सी बात आपके लिए सबसे सच है?",
        o: [
          ["बढ़ूँगा/बढ़ूँगी — पर उसी दीवार के भीतर जो मुझे पता है",                        0],
          ["बिना कुछ टूटे कोई असली बात नहीं होती",                                       1],
          ["मैं जोखिम नहीं लेता/लेती — मेरा सिस्टम नहीं झेल पाता",                        2],
          ["जब ज़मीन सचमुच तैयार होती है, मैं छलाँग लगाता/लगाती हूँ",                   3],
        ] },
    ],
    purpose_alignment: [
      { q: "आपको सबसे ज़्यादा किस चीज़ से लगता है कि आप 'ज़िंदा' हैं?",
        o: [
          ["एक दिन जो जैसा सोचा था, वैसा गुज़र गया",                                     0],
          ["जब जिन लोगों की परवाह है, वे मुझे सराहते हैं",                                1],
          ["पूरी आज़ादी — किसी का कोई क़र्ज़ नहीं",                                     2],
          ["कुछ बनाना या मदद करना जो मेरे बाद भी टिके",                                  3],
        ] },
      { q: "जीवन के इस पड़ाव पर सबसे ज़्यादा क्या ढूँढ रहे हैं?",
        o: [
          ["शांति",                                                                    0],
          ["सफलता — मुझे लगना चाहिए कि मैं जीत रहा/रही हूँ",                            1],
          ["आज़ादी — उम्मीदों से, अतीत से",                                             2],
          ["उद्देश्य — जीने से बड़ा एक कारण",                                            3],
        ] },
      { q: "'अच्छे से जी गई ज़िंदगी' आपको कैसी दिखती है?",
        o: [
          ["शांत, दयालु, अनहिली",                                                       0],
          ["ऊँची, मशहूर, याद रखी गई",                                                    1],
          ["आज़ाद, अपनी मर्ज़ी की",                                                    2],
          ["सार्थक — कोई कहीं इसके कारण बेहतर हुआ",                                     3],
        ] },
      { q: "अपने सारे सपनों को हड्डी तक छाँटें, तो क्या बचता है?",
        o: [
          ["सुरक्षित और स्थिर रहने की चाह",                                              0],
          ["देखे और याद किए जाने की चाह",                                                1],
          ["इस सब से मुक्त होने की चाह",                                                2],
          ["अपने से बड़ी किसी चीज़ के लिए ज़रूरी होने की चाह",                            3],
        ] },
    ],
    self_trust: [
      { q: "किसका डर ज़्यादा है?",
        o: [
          ["असफलता का",                                                                0],
          ["भुला दिए जाने का",                                                          1],
          ["अर्थहीनता का",                                                              2],
          ["पछतावे का",                                                                3],
        ] },
      { q: "अपनी ज़िंदगी के बारे में जो डर आप ज़ोर से नहीं कहते — क्या है वो?",
        o: [
          ["कि मैं ग़लत दिशा चुनूँगा/चुनूँगी और बहुत देर हो जाएगी",                       0],
          ["कि लोग देखेंगे मैं अपने सच में नहीं जी रहा/रही",                              1],
          ["कि मैं अपनी बनाई ज़िंदगी को पहचान न पाऊँ",                                  2],
          ["कि यह एक मौक़ा मेरे बग़ैर बिताए निकल जाएगा",                                 3],
        ] },
      { q: "जो बन सकते हैं, वो बनने से क्या रोकता है?",
        o: [
          ["कहीं मैं ग़लत तो नहीं समझ रहा/रही — छलाँग वापस नहीं होगी",                  0],
          ["अपने क़रीबी लोग समझ नहीं पाएँगे",                                            1],
          ["अभी जो ज़िंदगी है, उसका आकार खो दूँगा/दूँगी",                                2],
          ["वो नया संस्करण भी शायद काफ़ी न हो",                                        3],
        ] },
      { q: "मरने से पहले ख़ुद को क्या साबित करना चाहते हैं?",
        o: [
          ["कि जो भी हुआ, मैं दयालु रहा/रही",                                            0],
          ["कि मैं वो नहीं था/थी जो लोगों को दिखा",                                     1],
          ["कि मैं आख़िर तक अपना/अपनी बना/बनी रहा/रही",                                  2],
          ["कि मैंने वो काम किया जिसके लिए मैं यहाँ आया/आयी थी",                        3],
        ] },
    ],
  },

  "Major Decision": {
    decision_confidence: [
      { q: "जब कोई सचमुच भारी फ़ैसला सामने होता है, आप उसे कैसे मिलते हैं?",
        o: [
          ["धीरे — हर पहलू समझना ज़रूरी है",                                            0],
          ["तेज़ — जान लिया, तो जान लिया",                                             1],
          ["पहले दो-तीन अपनों की राय चाहिए",                                             2],
          ["उस पर बैठा/बैठी रहता/रहती हूँ — डेडलाइन तय कर दे",                          3],
        ] },
      { q: "जब दिल और दिमाग़ आपस में असहमत हों, आमतौर पर कौन जीतता है?",
        o: [
          ["दिमाग़ — तर्क सुरक्षित लगता है",                                              0],
          ["दिल — यह शायद ही ग़लत होता है, भले क़ीमत माँगे",                            1],
          ["जिस पर भरोसा है, उनकी सलाह — दोनों से ज़्यादा",                             2],
          ["कोई नहीं — मैं दोनों के बीच काफ़ी देर अटका/अटकी रहता/रहती हूँ",              3],
        ] },
      { q: "किसी फ़ैसले को सही मानने के लिए क्या चाहिए आपको?",
        o: [
          ["हर कोण जँच जाए, और एक रात से ज़्यादा सोच लिया हो",                          0],
          ["कहते ही शरीर हल्का हो जाए",                                                 1],
          ["जिनकी परवाह है, उनका सिर हामी में हिल जाए",                                 2],
          ["अब उसे बार-बार सोचना बंद हो जाए",                                            3],
        ] },
      { q: "अपने बड़े फ़ैसलों के तरीक़े के बारे में आपने क्या सीखा?",
        o: [
          ["ज़्यादा सोचता/सोचती हूँ — पर सोच अक्सर बचाती है",                             0],
          ["अपने पर पहले से ज़्यादा जल्दी भरोसा करने लगा/लगी हूँ",                       1],
          ["सही आदमी साथ हो तो बेहतर तय करता/करती हूँ",                                 2],
          ["अभी भी एक पल ज़्यादा अटकता/अटकती हूँ — और ज़िंदगी वैसे ही आगे बढ़ जाती है", 3],
        ] },
    ],
    emotional_clarity: [
      { q: "बड़ा फ़ैसला सामने होने पर सबसे ज़्यादा क्या तंग करता है?",
        o: [
          ["इसे लेकर मैं जो महसूस कर रहा/रही हूँ, उसे नाम नहीं दे पाना",                  0],
          ["ऐसा लगना कि दूसरे मुझे इस तरफ़ धकेल रहे हैं",                                1],
          ["कुछ भी नहीं महसूस होता — बस भार लगता है",                                   2],
          ["जल्द कुछ करना है — इस दबाव का तनाव",                                        3],
        ] },
      { q: "फ़ैसला लेकर बाद में मन में बैठे नहीं, तो क्या होता है?",
        o: [
          ["असहजता के साथ बैठता/बैठती हूँ — यह मुझे बताएगी क्या है",                     0],
          ["किसी को दोष देने की तलाश — हालात, दबाव",                                    1],
          ["चुप हो जाता/जाती हूँ — इस बारे में बात करना बंद",                             2],
          ["उसी दिन एक छोटा सुधार करता/करती हूँ",                                      3],
        ] },
      { q: "बड़े फ़ैसले के पास कौन-सी भावना छा जाती है?",
        o: [
          ["एक ईमानदार भारीपन, जिसका मुझे नाम पता है",                                  0],
          ["चिढ़ — इतना कुछ मुझ पर क्यों?",                                              1],
          ["एक खोखली चुप्पी — मैंने सोचना बंद कर दिया",                                   2],
          ["एक स्थिर तैयारी — मैं अंदर जा रहा/रही हूँ, तैयार",                            3],
        ] },
      { q: "कठिन चुनाव के बाद कैसा महसूस करते हैं?",
        o: [
          ["नरम — सच अंदर बैठ रहा है",                                                  0],
          ["तेज़ — कोई हिस्सा अभी भी नतीजे से लड़ रहा है",                                1],
          ["सुन्न — किसी से बात करना बंद",                                                2],
          ["ध्यान — तुरंत अगले क़दम में लग जाता/जाती हूँ",                              3],
        ] },
    ],
    risk_readiness: [
      { q: "जो फ़ैसले पलटे नहीं जा सकते — उनसे रिश्ता कैसा है?",
        o: [
          ["आरामदेह नहीं — मुझे लौटने वाले दरवाज़े चाहिए",                              0],
          ["ठीक — असल फ़ैसलों की अक्सर वापसी नहीं होती",                                 1],
          ["बचता/बचती हूँ — पलटने की गुंजाइश चाहिए साँस लेने के लिए",                    2],
          ["सही पल पर, बिना निकास के भी क़दम बढ़ाता/बढ़ाती हूँ",                        3],
        ] },
      { q: "जब जोखिम सबसे ज़्यादा हो, अंदर क्या जीतता है?",
        o: [
          ["सुरक्षा — मैं सुरक्षित रास्ता चुनने लगता/लगती हूँ",                            0],
          ["विकास — जो मुझे बढ़ाए, उधर झुकता/झुकती हूँ",                                1],
          ["जमना — बिल्कुल हिल नहीं पाता/पाती",                                          2],
          ["समय — कब चलना है और कब रुकना है, यह पता है",                              3],
        ] },
      { q: "जो फ़ैसला पूरी ज़िंदगी बदल दे — उसके सामने आप कैसे हैं?",
        o: [
          ["जो बनाया है, वो नए बदलाव से ज़्यादा प्रिय है",                                0],
          ["इसका इंतज़ार था — जल्दी क़दम उठाऊँगा/उठाऊँगी",                             1],
          ["रुक जाऊँगा/जाऊँगी — 'बाद' का न-जानना असहनीय है",                            2],
          ["जब पल पूरी तरह पका होगा, तब हाँ",                                            3],
        ] },
      { q: "जिन फ़ैसलों पर आपको सबसे ज़्यादा गर्व है, उनमें जोखिम की भूमिका क्या थी?",
        o: [
          ["बहुत कम — सुरक्षा ने मुझे धीरे-धीरे बनाया",                                    0],
          ["लगभग सब — जो था वो जोखिम में डाला और बड़ा हुआ/हुई",                        1],
          ["नाम मात्र की — जोखिम वाले आज भी याद में डराते हैं",                           2],
          ["सही समय — जब ज़रूरी था, तब जोखिम लिया",                                     3],
        ] },
    ],
    purpose_alignment: [
      { q: "अभी आप असल में किस तरह का जवाब ढूँढ रहे हैं?",
        o: [
          ["आश्वासन — जो भी चुनूँ, मैं ठीक रहूँगा/रहूँगी",                               0],
          ["पहचान — कि यह मायने रखता है, कि मैं मायने रखता/रखती हूँ",                    1],
          ["इजाज़त — कि जो चाहता/चाहती हूँ, वो चाहने का हक़ मुझे है",                    2],
          ["साहस — क्योंकि करना क्या है, वो मुझे पहले से पता है",                       3],
        ] },
      { q: "इस फ़ैसले के नीचे असल में आप किस-किस के बीच चुन रहे हैं?",
        o: [
          ["सुरक्षा और बदलाव के बीच",                                                    0],
          ["देखे जाने और अनदेखा किए जाने के बीच",                                        1],
          ["आज़ादी और वफ़ादारी के बीच",                                                 2],
          ["जो मैं था/थी और जो मैं बन सकता/सकती हूँ, उसके बीच",                       3],
        ] },
      { q: "कौन-सा नतीजा मिले तो आप चैन की साँस लेंगे?",
        o: [
          ["एक स्थिर, शांत, बिना घटना वाला भविष्य",                                     0],
          ["इस फ़ैसले के लिए सराहा जाना",                                                1],
          ["फिर से चुनने की आज़ादी",                                                    2],
          ["एक ज़िंदगी जो सचमुच मायने रखे — मेरे लिए और औरों के लिए",                    3],
        ] },
      { q: "अतीत के किस फ़ैसले ने आपकी ज़िंदगी सबसे ज़्यादा बदली?",
        o: [
          ["एक ऐसा जो कुछ ज़रूरी बचा गया",                                              0],
          ["एक ऐसा जिसके लिए लोगों ने आख़िर मुझे नोटिस किया",                            1],
          ["एक ऐसा जिसने मुझे मेरी ज़िंदगी वापस दी",                                    2],
          ["एक ऐसा जिससे वो अर्थ शुरू हुआ जिसमें मैं आज भी जीता/जीती हूँ",              3],
        ] },
    ],
    self_trust: [
      { q: "पिछले फ़ैसले को याद करते हैं, तो सबसे ज़्यादा क्या चुभता है?",
        o: [
          ["कि थोड़ा और ग़ौर से देखता/देखती, तो पहले पता चल जाता",                    0],
          ["कि लोगों ने मुझे लड़खड़ाते हुए देखा",                                        1],
          ["कि हालात ने मुझे चलाया, मैंने हालात को नहीं",                                 2],
          ["कि मैंने ज़िंदगी का एक बड़ा रूप गुज़र जाने दिया",                           3],
        ] },
      { q: "इस फ़ैसले के नीचे कौन-सा डर छिपा है?",
        o: [
          ["कि मैं ग़लत दरवाज़ा चुनूँगा/चुनूँगी और लौट नहीं पाऊँगा/पाऊँगी",              0],
          ["कि लोग बाद में मुझे अलग नज़र से देखेंगे",                                    1],
          ["कि मेरी ज़िंदगी की ज़मीन हिल जाएगी",                                        2],
          ["कि मैं कभी वो नहीं बन पाऊँगा/पाऊँगी जो बन सकता/सकती था/थी",                3],
        ] },
      { q: "जो अंदर से सच पता है, उसे चुनने से क्या रोकता है?",
        o: [
          ["शायद मैं फिर भी ग़लत हूँ — यह पक्का होना डराता है",                            0],
          ["दूसरे इस चुनाव को जज करेंगे",                                                1],
          ["इससे बहुत कुछ, बहुत जल्दी बदल जाएगा",                                      2],
          ["अगर यहाँ भी चूक गया/गयी, तो और कुछ बड़ा तो है नहीं",                       3],
        ] },
      { q: "फ़ैसला लेने से पहले आपको सचमुच क्या महसूस करना चाहिए?",
        o: [
          ["कि मैंने इसे इतना सोचा है कि इसे बचा भी सकूँ",                                0],
          ["कि किसी ने चुपचाप मुझे इस पर देखा है",                                      1],
          ["कि ज़मीन हिले भी तो मैं आगे चला/चली सकूँगा/सकूँगी",                          2],
          ["कि जो मैं बन रहा/रही हूँ, वो इस फ़ैसले से सहमत है",                          3],
        ] },
    ],
  },
};
